var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 666,
    viewBox: "0 0 1440 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512C1.00011 503 0 168 0.500014 0H1440C1441.83 170.833 1444.4 512.5 1440 512.5C1434.5 512.5 1341 491 1242 356C1221.83 328.5 1151 199 912.5 149C666.5 93 646.5 497 375 611C96 694.577 11 514 0 512Z",
    fill: "url(#paint0_linear_84_2003)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 186V0H1440V28C1314.5 67.5 1044 111.5 967 162C734.5 299 931 469 831 612C746.5 704.5 467.012 740 0 186Z",
    fill: "url(#paint1_linear_84_2003)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.5 472C928.5 525 502 376 167 0H1438C1442.83 58.3333 1449.6 176.6 1438 183C1306 210 1239 425.864 1094.5 472Z",
    fill: "url(#paint2_linear_84_2003)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_2003",
    x1: 1141.26,
    y1: 94.9634,
    x2: 924.773,
    y2: 818.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A063D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471575,
    stopColor: "#7A1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A063D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_84_2003",
    x1: 1139.33,
    y1: 99.8802,
    x2: 901.595,
    y2: 854.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A063D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471575,
    stopColor: "#7A1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751363,
    stopColor: "#0D073E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A063D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_84_2003",
    x1: 1317.5,
    y1: -37,
    x2: 1161.19,
    y2: 647.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A063D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471575,
    stopColor: "#7A1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711449,
    stopColor: "#0F0638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A063D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBg);
export default __webpack_public_path__ + "static/media/banner-bg.313233253454d7e10c41d735240f965e.svg";
export { ForwardRef as ReactComponent };